import React from "react";
import classNames from "classnames";
import { NavigationMenu } from "@design-system/Navigation/NavigationMenu";
import { useAggregatedFiltersContext } from "./AggregatedFilters.context";
import css from "./AggregatedFiltersOverlay.module.scss";

interface Props {
    navigation: React.ReactNode;
    content: React.ReactNode;
    filterClassname?: string;
}

export const AggregatedFiltersOverlay: React.FC<Props> = ({
    navigation,
    content,
    filterClassname,
}) => {
    const { activeTab } = useAggregatedFiltersContext();

    return (
        <section className={css.layout} data-active-tab={activeTab}>
            <nav className={css.tabs}>
                <NavigationMenu small>{navigation}</NavigationMenu>
            </nav>
            <main className={classNames(css.filter, filterClassname)}>
                {content}
            </main>
        </section>
    );
};
